import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de masse d'eau - Calcul de la masse d'eau basé sur le volume et la densité";
const DESCRIPTION =
  "Calculatrice de masse d'eau - Calcul de la masse d'eau basé sur le volume et la densité. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "water mass, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/water-mass/";
function Calculator() {
  const [waterVolume, setWaterVolume] = useState("");
  const [waterMass, setWaterMass] = useState("");
  const [error, setError] = useState("");
  const waterDensity = 1000;
  const handleCalculate = () => {
    if (!waterVolume) {
      setError("Veuillez entrer le volume d'eau en mètre cube correctement");
      setWaterMass("");
      return;
    }
    const volumeValue = parseFloat(waterVolume);
    if (isNaN(volumeValue) || volumeValue < 0) {
      setError("Veuillez entrer une valeur correcte et non négative pour le volume d'eau en mètre cube");
      setWaterMass("");
      return;
    }
    const mass = volumeValue * waterDensity;
    setWaterMass(mass.toFixed(2));
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Méthode de calcul de la masse d'eau</h2>
                <p>
                  Pour calculer la masse d'eau, la relation entre le volume et la densité d'eau est utilisée. Vous devez entrer le volume d'eau en unités de mètre cube, puis ce volume est multiplié par la densité d'eau pour obtenir la masse en kilogrammes.
                </p>
                <p>
                  <strong>Formule de calcul :</strong> <br />
                  Masse d'eau = Volume (mètre cube) × Densité d'eau (kilogramme/mètre cube)
                </p>
                <p>
                  Vous pouvez utiliser cette calculatrice pour déterminer la masse d'eau avec précision en fonction des valeurs que vous entrez. Il vous suffit d'entrer le volume et la densité, et vous obtiendrez le résultat rapidement et facilement.
                </p>
                <b >
                  Dernière mise à jour : {" "}
                  <time dateTime="2026-01-10">28/02/2026</time>
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Volume d'eau (m³)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="Entrez le volume"
                        value={waterVolume}
                        onChange={(e) => setWaterVolume(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      waterMass !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Masse d'eau : {waterMass} kilogrammes
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <br />
    </div>
  );
}
export default Calculator;
